// Estado de UI LOCAL do módulo — não entra no doc e não é desfazível.

import type { SudokuDoc, SudokuDificuldade } from './doc';
import type { SudokuAction } from './reducer';

export interface SudokuUi {
  /**
   * Dificuldade escolhida no Inspector, a que o próximo "Gerar" vai usar. Mora aqui
   * e não no doc porque escolher no Select ainda não mudou tabuleiro nenhum —
   * sujar o documento (e gastar um undo) só por mexer no Select seria mentira.
   * O doc guarda a dificuldade da ÚLTIMA geração, e é dela que este campo parte.
   */
  dificuldade: SudokuDificuldade;
}

export function initialSudokuUi(doc: SudokuDoc): SudokuUi {
  return { dificuldade: doc.dificuldade };
}

/**
 * Chave de coalescing do undo. Alternar a MESMA casa em janela curta é um undo só;
 * casas diferentes são marcos diferentes.
 *
 * `GENERATE` devolve `null` de propósito (S6): o "Gerar" joga o tabuleiro inteiro
 * fora, então ele nunca pode ser engolido pela entrada anterior — o admin tem que
 * conseguir desfazer um clique acidental e recuperar o trabalho.
 */
export function coalesceKeyFor(action: SudokuAction): string | null {
  switch (action.type) {
    case 'TOGGLE_GIVEN':
      return `given:${action.index}`;
    case 'SET_TITULO':
      return 'titulo';
    default:
      return null;
  }
}
